import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { apiClient, ApiResponse } from "@/core/api/axios-client";
import { PageResponse } from "@/core/api/types/page";

export const usePageData = (endpoint: string) => {
  const { data, isLoading, isFetching, error } = useQuery({
    queryKey: ["page", endpoint],
    queryFn: async () => {
      const response = await apiClient.post<ApiResponse<PageResponse>>(
        `/${endpoint}`,
        {}
      );
      return response.data.data;
    },
    enabled: !!endpoint,
    // Mantiene i dati precedenti mentre carica i nuovi (no flash bianco)
    placeholderData: keepPreviousData,
    // Considera i dati freschi per 30 secondi
    staleTime: 30 * 1000,
  });

  return {
    pageData: data,
    isLoading,
    isFetching, // true quando sta aggiornando in background
    error,
  };
};
